import React from 'react';
import PropTypes from 'prop-types';

import { t } from '../../../../../modules/infra/i18n';
import LinkHeader from './linkHeader';
import { INTEGRATIONS_PATH } from '../constants';

const MailchimpIntegrationOutlet = ({ baseUrl, children }) => (
  <div className="mailchimp-integration">
    <LinkHeader
      heading={t('settings:integrations.mailchimp.integrate_title')}
      label={t('common:buttons.cancel')}
      link={`${baseUrl}${INTEGRATIONS_PATH}`}
    />
    {children}
  </div>
);

MailchimpIntegrationOutlet.propTypes = {
  baseUrl: PropTypes.string.isRequired,
  children: PropTypes.node,
};

MailchimpIntegrationOutlet.defaultProps = {
  children: null,
};

export default MailchimpIntegrationOutlet;
